'use client'

import { useRouter } from 'next/navigation'

import { BaseMobileMenu } from '@common/components/MobileMenu'
import { useMobileNavigation } from '@common/components/MobileMenu/variants/AcademyMobileMenu/hooks/useMobileNavigation'
import { ACADEMY_QUICKSTART_NAV_ITEMS } from '@common/config/academyQuickStartNavItems'
import { AppVariant } from '@common/enums'

import type { CategoryNode, TutorialSection } from '@/lib/github/types'
import { ACADEMY_MOBILE_MENU_TEST_IDS } from '@/shared/docs-test-ids.const'

import { GuestAcademyNavigation } from './GuestAcademyNavigation'

type AcademyMobileMenuProps = {
  isOpen?: boolean
  onClose?: () => void
  tutorialSections?: TutorialSection[]
  currentTutorialPath?: string
  categoryTree?: CategoryNode[]
  rootArticles?: TutorialSection[]
}

export function AcademyMobileMenu({
  isOpen = false,
  onClose = () => {},
  tutorialSections,
  currentTutorialPath,
  categoryTree,
  rootArticles,
}: AcademyMobileMenuProps) {
  const router = useRouter()
  const resolvedSections =
    tutorialSections && tutorialSections.length > 0 ? tutorialSections : ACADEMY_QUICKSTART_NAV_ITEMS

  const handleNavigationClick = (path: string) => {
    router.push(path)
  }

  const nav = useMobileNavigation({
    tutorialSections: resolvedSections,
    categoryTree,
    rootArticles,
    onNavigationClick: handleNavigationClick,
    onClose,
    routeProfile: 'docs',
  })

  return (
    <BaseMobileMenu
      data-testid={ACADEMY_MOBILE_MENU_TEST_IDS.root}
      isOpen={isOpen}
      onClose={onClose}
      appVariant={AppVariant.ACADEMY}
      menuGroups={[]}
      onNavigationClick={handleNavigationClick}
      showProjectSelector={false}
      showWorkspaceSelector={false}
      navigationTopSlot={
        <GuestAcademyNavigation
          nav={nav}
          tutorialSections={resolvedSections}
          currentTutorialPath={currentTutorialPath}
        />
      }
    />
  )
}
